import { LinkProps } from "next/link";

import { TAnchorProps, TExternalAnchorProps } from "./types";
import { Wrapper, StyledLink } from "./styled";

const Anchor: React.FC<TAnchorProps> = ({
  href,
  underlined = false,
  color,
  withHoverEffect,
  ...restProps
}) => {
  const typedProps = restProps as Omit<LinkProps, "as">; // open to suggestions to avoid casting here
  return (
    <StyledLink
      {...typedProps}
      href={href}
      $underlined={underlined}
      $color={color}
      $withHoverEffect={withHoverEffect}
    />
  );
};

export const ExternalAnchor: React.FunctionComponent<TExternalAnchorProps> = ({
  underlined = false,
  color,
  isLandingPage,
  withHoverEffect = true,
  ...restProps
}) => {
  return (
    <Wrapper
      {...restProps}
      target={isLandingPage ? undefined : "_blank"}
      rel={isLandingPage ? undefined : "noopener noreferrer"}
      $underlined={underlined}
      $color={color}
      $withHoverEffect={withHoverEffect}
    />
  );
};

export default Anchor;
